import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "searchType"
}
const _hoisted_3 = { class: "value" }
const _hoisted_4 = { class: "createdStyles" }
const _hoisted_5 = { class: "openedStyles" }
const _hoisted_6 = {
  class: "label",
  for: "searchResult"
}
const _hoisted_7 = {
  class: "searchedStylesData row",
  style: {"min-height":"50px","padding":"10px"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "label",
  for: "recentlyCreatedStyles"
}
const _hoisted_10 = {
  class: "styles",
  style: {"padding":"10px"}
}
const _hoisted_11 = {
  class: "styleData row",
  style: {"min-height":"50px"}
}
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.localshowSearchView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "k-icon k-button-icon k-i-x",
                    style: {"float":"right","border":"none","background":"none"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideSearchView && _ctx.hideSearchView(...args)))
                  })
                ])
              ]),
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("searchView.searchResult")), 1),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedStylesData, (style) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "name column",
                    key: style.id
                  }, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.openStyle(style.id)),
                      style: {"font-size":"12px"}
                    }, _toDisplayString(style.name), 9, _hoisted_8)
                  ]))
                }), 128))
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("hr", { style: {"width":"100%","text-align":"left","margin-left":"0"} }, null, -1)),
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("searchView.recentlyCreatedStyles")), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shortStyleList, (data) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "data column",
                      key: data.id
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.openStyle(data.id)),
                        style: {"font-size":"12px"}
                      }, _toDisplayString(data.name), 9, _hoisted_12)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}